import React from 'react';

const HistoryPage = () => {
  return (
    <div className="p-6">
      <h1 className="text-xl font-semibold mb-4">Historique des publications</h1>
      <p className="text-gray-600">Liste des posts déjà publiés, avec date et statut.</p>
    </div>
  );
};

export default HistoryPage;
